export default __webpack_public_path__ + "static/media/3.b130bd6c.png";